import React from "react";
import { Row, Col, Typography } from "antd";
import { css } from "@emotion/css";

const { Title } = Typography;
function LoginSignupScreen() {
  return (
    <Col
      span={12}
      xs={24}
      sm={24}
      md={24}
      lg={12}
      xl={12}
      xxl={12}
      className={[
        "log-left-col-bg",
        css`
          @media (max-width: 700px) {
            display: none !important;
          }
        `,
      ]}
    >
      <Row className="log-left-col">
        <Col span={24}>
          {}
          <img alt="" src={"/pics/Meet-max-logo-white.png"} width={150} />
        </Col>{" "}
        <div
          className={css`
            @media (max-width: 1288px) {
              padding-top: 100px;
            }
          `}
        />
        <Col span={24} className="log-left-content-col">
          <img alt="" src="/pics/Illustration-01.png" width={500} />
        </Col>
        <Col span={24} className="log-left-content-col">
          <div
            className={css`
              @media (max-width: 1288px) {
                padding-top: 20px;
              }
            `}
          />
          <Title level={2} className="log-left-content-heading">
            Wholesome Work Management System
          </Title>
          <Title
            level={4}
            className="subtitle-Body-Large-Dark subtitle-Body-Large-padding"
          >
            Manage people, finance, and sales
          </Title>
          <div
            className={css`
              @media (max-width: 1288px) {
                padding-top: 30px;
              }
            `}
          />
        </Col>
      </Row>
    </Col>
  );
}

export default LoginSignupScreen;
